import { graphql } from 'gql';

export const otherCostTypesGql = graphql(`
    query otherCostTypes($methodology: ProjectMethodologyEnum!, $order: [CatalogOtherCostTypeDataSortInput!]) {
        otherCostTypes(methodology: $methodology, order: $order) {
            id
            uniqueId
            name
            isSystem
            canDelete
        }
    }
`);

export const otherCostTypeUniqueNameGql = graphql(`
    query isUniqueOtherCostType($catalogOtherCostTypeId: Int, $name: String!, $methodology: ProjectMethodologyEnum!) {
        isUniqueOtherCostType(catalogOtherCostTypeId: $catalogOtherCostTypeId, name: $name, methodology: $methodology) {
            result
        }
    }
`);

export const otherCostTypeCreateGql = graphql(`
    mutation createCatalogOtherCostType($input: CatalogOtherCostTypeCreateInput!) {
        createCatalogOtherCostType(input: $input) {
            message
            result
            validation {
                property
                message
                metadata
            }
        }
    }
`);

export const otherCostTypeEditGql = graphql(`
    mutation updateCatalogOtherCostType($input: CatalogOtherCostTypeUpdateInput!) {
        updateCatalogOtherCostType(input: $input) {
            message
            result
            validation {
                property
                message
                metadata
            }
        }
    }
`);

export const otherCostTypeRemoveGql = graphql(`
    mutation removeCatalogOtherCostType($catalogOtherCostTypeId: Int!) {
        removeCatalogOtherCostType(catalogOtherCostTypeId: $catalogOtherCostTypeId) {
            message
            result
            validation {
                property
                message
                metadata
            }
        }
    }
`);
